import { REQUIRED_ERROR } from './validator/Required.validator'
import { WRONG_EMAIL_ERROR } from './validator/IsEmail.validator'
import { WRONG_BUSINESS_EMAIL_ERROR } from './validator/IsBusinessEmail.validator'
import { getGtmClient } from 'marketing-site/lib/gtm'
import { IFormField } from './../@types/FormField'
import { FormikErrors } from 'formik'
import {
  googleTagManagerCustomEvents,
  triggerGoogleTagManagerCustomEvent,
} from 'marketing-site/src/library/utils'
/**
 * The Google Client ID stored in the _ga cookie has a prefix that needs to be removed before sending
 * it to Marketo. For example, the if the cookie contains "GA.1.2546404655.1631045250", we should
 * pass the sanitized ID "2546404655.1631045250" to Marketo.
 */
const areAllFieldsEmpty = (
  errors: FormikErrors<Record<string, any>>,
  filteredFields: IFormField[],
) => {
  let emptyElements = 0
  Object.entries(errors).forEach(([, detail]) => {
    if (detail == REQUIRED_ERROR) {
      emptyElements++
    }
  })

  return emptyElements == filteredFields.length
}

const sanitizeDetail = (detail: string) => {
  switch (detail) {
    case REQUIRED_ERROR:
      detail = 'missing field'
      break
    case WRONG_EMAIL_ERROR:
      detail = 'wrong email format'
      break
    case WRONG_BUSINESS_EMAIL_ERROR:
      detail = 'non-business email'
      break
    default:
      detail = detail.toLocaleLowerCase()
      break
  }

  return detail
}

const sanitizeContext = (inputName: string, detail: string) => {
  const inputNameSanitized = inputName.replace(/([A-Z])/g, ' $1').slice(1)
  const detailSanitized = sanitizeDetail(detail)

  return `Input ${inputNameSanitized} failed with the following detail: ${detailSanitized}`
}

export default async function sendInputMetrics(
  errors: FormikErrors<Record<string, any>>,
  filteredFields: IFormField[],
) {
  const gtmClient = await getGtmClient()
  if (areAllFieldsEmpty(errors, filteredFields)) return

  Object.entries(errors).forEach(([errorName, detail]) => {
    const isEmailType = errorName.toLowerCase().includes('email')
    if (!isEmailType || (isEmailType && detail != REQUIRED_ERROR)) {
      const event = {
        /* eslint-disable @typescript-eslint/naming-convention */
        action: 'Submission',
        object: 'Form',
        gtm_tracking_pageview_id: gtmClient.pageviewId || null,
        place: window.location.pathname,
        context: sanitizeContext(errorName, detail as string),
        /* eslint-enable @typescript-eslint/naming-convention */
      }

      triggerGoogleTagManagerCustomEvent(
        googleTagManagerCustomEvents.marketoFormValidationFailure,
        event,
      )
      const pageviewId = gtmClient.pageviewId || 0
      const identifier = `failed-input-${event.action}-${event.object}`
      gtmClient.recordEvent(identifier, pageviewId, event)
    }
  })
}
